import React, { RefObject, useEffect, useState } from 'react';
import styles from './CartResume.module.scss';
import { FaLock } from 'react-icons/fa';

interface CartItem {
    title: string;
    valor: number;
}

interface CartResumeProps {
    items: CartItem[];
    discount?: number | RefObject<number>;  // Pode ser número ou ref
    paymentApproved?: boolean; // Adicionado para compatibilidade com PaymentBrick
}

const LockIcon = FaLock as React.FC<{ size?: number; color?: string }>;

const CartResume: React.FC<CartResumeProps> = ({ items, discount, paymentApproved }) => {
    const total = items.reduce((sum, item) => sum + item.valor, 0);

    // Estado para forçar re-render a cada segundo
    const [tick, setTick] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setTick(t => !t); // alterna valor para forçar re-render
        }, 1000);

        return () => clearInterval(interval);
    }, []);

    // Aqui obtemos o valor atual do desconto
    // Se discount for ref, acessa discount.current, senão o valor direto
    const discountValue =
        typeof discount === 'number' ? discount :
        discount && 'current' in discount ? discount.current ?? 0 :
        0;

    return (
        <div className={[styles["payment-summary-box"], "mx-auto"].join(' ')}>
            <div className="text-start mb-3">
                <h6 className="fw-bold">Detalhes do pagamento</h6>

                {items.map((item, index) => (
                    <div key={index} className="d-flex justify-content-between">
                        <span>{item.title}</span>
                        <span>{
                            item.valor.toLocaleString('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                            })
                        }</span>
                    </div>
                ))}
                {(discountValue !== 0) ? (
                    <div className="d-flex justify-content-between">
                        <span>{discountValue > 0 ? 'Desconto' : 'Acréscimo'}</span>
                        <span style={{ color: discountValue > 0 ? 'green' : 'red' }}>
                            {
                                discountValue < 0 ? '+' : ''
                            }{
                                (-discountValue).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                })
                            }
                        </span>
                    </div>
                ) : null}
            </div>

            <hr className="my-3" />

            <div className="d-flex justify-content-between fw-bold mb-3">
                <span>Você {paymentApproved ? 'pagou' : 'pagará'}</span>
                <span>{
                    (total - discountValue).toLocaleString('pt-BR', {
                        style: 'currency',
                        currency: 'BRL',
                    })
                }</span>
            </div>

            <div className="text-muted small d-flex align-items-center justify-content-center">
                <LockIcon size={16} />
                <span className={styles.securePaymentInfo}>Pagamento seguro</span>
            </div>
        </div>
    );
};

export default CartResume;
